import { render, staticRenderFns } from "./UpdateStatus.vue?vue&type=template&id=51fe2144"
import script from "./UpdateStatus.vue?vue&type=script&lang=js"
export * from "./UpdateStatus.vue?vue&type=script&lang=js"
import style0 from "./UpdateStatus.vue?vue&type=style&index=0&id=51fe2144&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports